import React from "react";
import CustomModalV1 from "components/custom-modal/CustomModalV1";
import Spinner from "images/image-component/Spinner";
import "./loading-modal.css";

interface Props {
  isOpen: boolean;
  loadingMsg: string;
}

function LoadingModal({ isOpen, loadingMsg }: Props) {
  return (
    <CustomModalV1 isOpen={isOpen}>
      <div className="v1-loading-modal">
        <p className="v1-loading-msg">{loadingMsg}</p>
        <div className="v1-loading-spinner">
          <Spinner size={24} color="var(--brand-hi)" />
        </div>
      </div>
    </CustomModalV1>
  );
}

export default LoadingModal;
